import createTableStore from "ds/components/Table/store/useTableStore";

import { SHARED_MODULES_TABLE_COLUMNS_CONFIG, SHARED_MODULES_TABLE_STORAGE_KEY } from "./constants";

const useSharedModulesTableStore = createTableStore({
  storageKey: SHARED_MODULES_TABLE_STORAGE_KEY,
  config: SHARED_MODULES_TABLE_COLUMNS_CONFIG,
});

export default useSharedModulesTableStore;
